import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Select, notification} from 'antd';

import {getDescriptionFromError} from "../utils/errors";
import {removeTaxFromGroup, getTaxGroup} from "./actions";
import {formItemLayout} from "../utils/style";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const Option = Select.Option;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class RemoveTaxFromGroupForm extends Component {
  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.taxGroupId !== this.props.match.params.taxGroupId) {
      this._load();
    }
  }

  _load = () => {
    const {taxGroupId} = decodeParams(this.props.match.params);
    this.props.getTaxGroup({taxGroupId});
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {taxGroupId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.removeTaxFromGroup({...values, taxGroupId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading, taxGroup} = this.props;
    const {name, taxes} = taxGroup;
    return (
      <Card title="Remove Tax From Group">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Tax Group"
          >
            {name}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Tax"
          >
            {getFieldDecorator('taxId', {
              rules: [{
                required: true,
                message: 'Tax is required'
              }]
            })(
              <Select>
                {(taxes || []).map(({taxId, name}) =>
                  <Option key={taxId} value={taxId}>{name}</Option>
                )}
              </Select>
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Remove Tax From Group
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

RemoveTaxFromGroupForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  removeTaxFromGroup: PropTypes.func.isRequired,
  getTaxGroup: PropTypes.func.isRequired,
  taxGroup: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

const RemoveTaxFromGroupPage = Form.create()(RemoveTaxFromGroupForm);

const mapStateToProps = state => ({
  taxGroup: state.tax.taxGroup || {},
  loading: state.tax.gettingTaxGroup || state.tax.removingTaxFromGroup,
});

const mapDispatchToProps = dispatch => ({
  getTaxGroup: payload => (dispatch(getTaxGroup(payload))),
  removeTaxFromGroup: payload => (dispatch(removeTaxFromGroup(payload)))
});

export default connect(mapStateToProps, mapDispatchToProps)(RemoveTaxFromGroupPage);



// WEBPACK FOOTER //
// ./src/Tax/RemoveTaxFromGroupPage.js